import ThingName from './thing-name';
import ThingDetailsLabels from './thing-details-labels';
import ThingDescription from './thing-description';

export {
    ThingDescription,
    ThingDetailsLabels,
    ThingName
};
